<template>
	<div>
		<van-steps :active="step_active" active-icon="success" active-color="#ff976a">
			<van-step>{{translate('withdraw_option')}}</van-step>
			<van-step>{{translate('rsswithdrawal_amount')}}</van-step>
			<van-step>{{translate('moderated')}}</van-step>
		</van-steps>

		<h4 class="h4_title">{{translate('account_balance')}}</h4>
		
		<van-cell-group>
			<van-cell :title="translate('amount_that_can_be_withdrawn')" :value="balance_show" />
		</van-cell-group>

		<h4 class="h4_title">{{translate('amount_rsswithdrawal_amount')}}</h4>

		<van-field
			clearable
			type="number"
			v-model="formItem.total"
			name="total"
			:label="translate('amount_rsswithdrawal_amount')"
			:placeholder="translate('amount_rsswithdrawal_amount')"
			:rules="[{ required: true, trigger: 'onChange', message: translate('fill_in_the_rsswithdrawal_amount') }]"
		/>
		<h4 class="h4_title">支付密码</h4>

		<van-field
			clearable
			type="password"
			v-model="formItem.password"
			name="password"
			label="支付密码"
			placeholder="支付密码"
		/>

		<p style="color: red;padding-left:15px;margin-top:15px;font-size:12px;">* 本业务将收取 10港币 手续费</p>

		<div class="common_block">
			<van-button type="warning" block @click="next">{{translate('amount_next_step')}}</van-button>
		</div>

		<div class="common_block">
			<p style="text-align: right;color: blue;" @click="goHistory">{{translate('rsswithdrawal_record')}}</p>
		</div>
	</div>
</template>

<script>
import {SHA1} from '../../utils/sha1.js';
	export default {
		name: 'rsswithdraw_other',
		data() {
			return {
				step_active: 1,

				formItem: {
					c: 1,
					total: "",
					token: "",
					bank_type: "",
					bank_info: "",
					symbol: "",
					password: ""
				},
				
				balance_show: "",
				balance: 0,
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {

				this.formItem.token = this.$route.query.token

				if (window.sessionStorage.getItem('total')) {
					this.formItem.total = window.sessionStorage.getItem('total')
				}

				this.init()
			}
		},
		methods: {
			init() {
				this.$axios({
					method: 'post',
					url: 'rss_withdraw/index', 
					data: {
						token: this.formItem.token,
						c: this.formItem.c
					}
				}).then ((res) => {
					if (res.success) {
						this.withdraw_tip = res.data.withdraw_tip
						
						this.balance = parseFloat(res.data.balance)
						this.balance_show = res.data.balance_show
						this.formItem.symbol = res.data.symbol

						window.sessionStorage.setItem('balance', this.balance)
					}
				})
			},
			next() {

				if (this.formItem.total == '') {
					this.$dialog.alert({
						message: this.translate('fill_in_the_rsswithdrawal_amount')
					})
					
					return false
				}
				if (this.formItem.password == '') {
					this.$dialog.alert({
						message: '请输入支付密码'
					})
					
					return false
				}
				var total = parseFloat(this.formItem.total)
						
				if (total <= 0) {
					this.$dialog.alert({
						message: this.translate('fill_in_the_rsswithdrawal_amount')
					})
					
					return false
				}

				total += 10
				
				if (total > this.balance) {
					this.$dialog.alert({
						message: this.translate('insufficient_account_balance') + this.balance_show
					})
					
					return false
				}
				let mps= SHA1(this.formItem.password)
				this.$axios({
					method: 'post',
					url: 'rss_withdraw/methods', 
					data: {
						token: this.formItem.token,
						currency_id: this.formItem.c,
						pay_password: mps
					},
				}).then ((res) => {
					if (res.success) {
						this.next2()
					} else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
				
			},
			next2(){
				this.$dialog.confirm({
					message: "请确认是否出金？"
				}).then(() => {
					
					let form = {
						c: this.formItem.c,
						withdraw_id: 4,
						market: 'HK',
						symbol: this.formItem.symbol,
						total: this.formItem.total,
						token: this.formItem.token,
						bank_type: "1000",
						bank_info: JSON.stringify([])
					}

					this.$axios({
						method: 'post',
						url: 'rss_withdraw/insert', 
						data: form
					}).then ((res) => {
						
						this.$toast.clear()
						
						if (res.success) {
							this.$toast.success({
								message:this.translate('rsswithdrawal_success_submitted')
							})

							window.sessionStorage.removeItem('c')

							this.$router.replace('/rsswithdraw/history?token=' + this.formItem.token)
						} else {
							this.$dialog.alert({
								message: res.error_text
							})
						}
					})
				}).catch(() => {
					return 0
				})
			},
			goHistory() {
				this.$router.push('/rsswithdraw/history?token=' + this.formItem.token)
			}
		},
	}
</script>
